import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

//添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home'),
  },
  {
    path: '/index.html',
    name: 'Home',
    redirect: '/',
    component: () => import('@/views/home'),
  },
  {
    path: '/okr',
    name: 'okr',
    component: () => import('@/views/okr'),
  },
  {
    path: '/amb',
    name: 'amb',
    component: () => import('@/views/amb'),
  },
  {
    path: '/course',
    name: '课程',
    component: () => import('@/views/course'),
  },
  {
    path: '/scheme',
    name: '解决方案',
    component: () => import('@/views/scheme'),
  },
  {
    path: '/price',
    name: '价格与服务',
    component: () => import('@/views/price'),
  },
  {
    path: '/idea',
    name: '我们的理念',
    component: () => import('@/views/idea'),
  },
  {
    path: '/renew',
    name: 'renew',
    component: () => import('@/views/renew'),
  },
]

const router = new Router({
  mode: 'history',//去掉#，
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js